import { AdminScreen, AdminStructure } from "structure/admin";
import { CLICK, componentWithVariants, demoFile, story, variant } from "system/demo";

demoFile('structure/admin');

componentWithVariants('AdminScreen', AdminScreen, {}, [
    variant(null, {
        state: {roles: ['Owner']},
        config: AdminStructure.defaultConfig
    }, [
        story('Go to Component Demo', [
            CLICK('Component Demo')
        ])
    ]),
    variant('Not an admin', {})
]);

